import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, Router } from '@angular/router';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StudentGuard implements CanActivate {
  
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    if (environment.currentUser != null && environment.currentUser.role == 2) {
      return true;
    } else {
      return this.router.createUrlTree(['/auth2/loginBook']);
    }
  }
  
}
